import { render, staticRenderFns } from "./SalesmanCompany.vue?vue&type=template&id=08d4b325&scoped=true"
import script from "./SalesmanCompany.vue?vue&type=script&lang=js"
export * from "./SalesmanCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4b325",
  null
  
)

export default component.exports